import { Customer } from 'server/shared/models/customer';
import { MappedCertificate } from 'server/shared/models/user';

export function getJobCustomerTariff(
  customer: Customer,
  originCustomerId: string,
  certificates: MappedCertificate[],
): string {
  const customerTariff = customer.customerTariffs?.jobTariffs?.find(
    (tariff) => tariff.targetCustomer.id === originCustomerId,
  );
  const tariff = customerTariff?.tariffs?.find((tariff) =>
    tariff.certificates.some((certificate) =>
      certificates.some((c) => c.id === certificate.id),
    ),
  );

  return tariff?.hourlyWage || '';
}

export function getEmploymentCustomerTariff(
  customer: Customer,
  originCustomerId: string,
  certificates: MappedCertificate[],
) {
  const customerTariff = customer.customerTariffs?.employmentTariffs?.find(
    (tariff) => tariff.targetCustomer.id === originCustomerId,
  );
  const tariff = customerTariff?.tariffs?.find((tariff) =>
    tariff.certificates.some((certificate) =>
      certificates.some((c) => c.id === certificate.id),
    ),
  );

  return tariff?.hourlyWage || '';
}
